import util from '../util'

let controller = 'OperadorFrontEndMfa'
export default Object.assign({}, util.GetCrud(controller, null), {
    SMS: function (dto) {
        return util.Axios.Post(controller + "/SMS", dto)
    },
    EMAIL: function (dto) {
        return util.Axios.Post(controller + "/EMAIL", dto)
    },
    BuscarSolcitacaoEmAberto: function (id) {
        return util.Axios.GetAll(controller + `/SolicitacaoEmAberto?codigoOperador=${id}`, {})
    },
    BuscarUltimaSolicitacao: function (id) {
        return util.Axios.GetAll(controller + `/UltimaSolicitacao?codigoOperador=${id}`, {})
    },
    CancelarUltimaSolicitacao: function (codigoOperador) {   
        return util.Axios.Post(controller + `/${codigoOperador}/CancelarUltimaSolicitacao`, {})
    },
})
